<div class="bg-gray-100">
  <div class="h-screen flex overflow-hidden" #mainContent>
    <div
      class="absolute block inset-y-0 bg-white text-black w-[300px] min-h-screen overflow-y-auto transition-transform transform -translate-x-full ease-in-out duration-300 z-30"
      #sidebar clickOutside (clickOutside)="onClickedOutside()">
      <div class="p-3 h-[calc(100%-56px)]">
        <nav
          class="w-55 mt-[2.5rem] xl:w-[17rem] scrollbar-thumb-rounded scrollbar-track-rounded h-full flex-col justify-between overflow-auto bg-background transition-all duration-300 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-card lg:flex">
          <div class="h-14 fixed top-0 w-[275px] flex items-center justify-between border-b border-dashed bg-white">
            <!-- Logo -->
            <div class="flex items-center">
              <b class="text-lg ml-1 pl-2 font-bold text-foreground">
                Common Settings
              </b>
            </div>
            <button (click)="toggleSidebar()"
              class="mt-2 rounded text-muted-foreground/50 transition-all duration-200 focus:outline-none hover:text-muted-foreground">
              <mat-icon class="material-icons-outlined">close</mat-icon>
            </button>

            <!-- Separator -->
            <div class="pt-3">
              <hr class="border-dashed border-muted" />
            </div>
          </div>

          <!-- Menu Items -->
          <app-sidebar-menu></app-sidebar-menu>

        </nav>

      </div>
    </div>

    <div class="flex-1 flex flex-col overflow-hidden">
      <app-navbar (toggleNavbar)="toggleSidebar()"></app-navbar>
      <!-- main content -->
      <main class="flex-grow flex min-h-0">
        <section class="hs-overlay [--auto-close:lg]
          hs-overlay-open:translate-x-0
          -translate-x-full transition-all duration-300 transform
          w-[60px]
          hidden        
          bg-white border-e border-gray-200
          lg:block lg:translate-x-0 lg:end-auto lg:bottom-0
          dark:bg-neutral-800 dark:border-neutral-700
          z-50
         " *ngIf="!showBackdrop">
          <app-sidebar (openSidebarDrawer)="toggleSidebar()"></app-sidebar>
        </section>

        <!-- section content -->
        <section
          class="flex min-h-0 flex-col flex-auto border-l p-3 overflow-auto scrollbar-thumb-rounded scrollbar-track-rounded scrollbar-thin scrollbar-track-transparent scrollbar-thumb-card">
          <router-outlet></router-outlet>
        </section>
      </main>

    </div>
  </div>

</div>

<app-custom-backdrop *ngIf="showBackdrop"></app-custom-backdrop>